module.exports = __webpack_public_path__ + "static/media/XcodeSim.dfad6b4a.png";